var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"320px"}},[_c('div',{staticStyle:{"text-align":"left !important"}},[_c('VueApexCharts',{attrs:{"type":"bar","height":"285","options":_vm.options,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }